import { Badge, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { VerificationPipelineStatusGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { Icon } from 'packages/common-frontend/components/icons';

const statusConfigs: Record<
  VerificationPipelineStatusGQLType,
  { bg: string; color: string; label: string; icon?: string }
> = {
  // TODO(jon): split this up into approved and rejected
  complete: {
    bg: 'green.100',
    color: 'green.400',
    label: 'Reviewed',
  },
  awaitingApproval: {
    bg: 'blue.100',
    color: 'blue.400',
    label: 'Ready to verify',
  },
  error: {
    bg: 'red.100',
    color: 'red.400',
    label: 'Error',
  },
  notStarted: {
    bg: 'gray.100',
    color: 'gray.900',
    label: 'Not started',
  },
  inProgress: {
    bg: 'gray.100',
    color: 'gray.900',
    label: 'In progress',
  },
  superseded: {
    bg: 'gray.100',
    color: 'gray.900',
    label: 'Expired',
  },
  remediationRequested: {
    bg: 'red.100',
    color: 'red.400',
    label: 'Remediation Requested',
    icon: 'circle-exclamation',
  },
};

export const StatusBadge = ({
  value,
}: {
  value: VerificationPipelineStatusGQLType;
}) => {
  const { bg, color, label, icon } = statusConfigs[value];

  return (
    <Badge
      variant="subtle"
      padding="8px 16px"
      height="40px"
      borderRadius="8px"
      alignItems="center"
      bg={bg}
      color={color}
      fontSize="16px"
      textTransform="none"
    >
      <Flex alignItems="center" style={{ gap: '16px' }}>
        {icon && <Icon icon={icon} size="20px" />}
        <Text fontWeight={500}>{label}</Text>
      </Flex>
    </Badge>
  );
};
